import { normalizeHighlights } from "./generalBoardHighlights";

export const DEFAULT_GENERAL_BOARD_CONFIG = {
  columns: {
    callNumber: { visible: true },
    ra: { visible: true },
    name: { visible: true },
    absencesDiscipline: { visible: true },
    absencesPeriod: { visible: true },
    absencesTotal: { visible: true },
    absencesPercentDiscipline: { visible: true },
    absencesPercentPeriod: { visible: true },
    absencesPercentTotal: { visible: true },
    grades: { visible: false }
  },
  highlights: []
};

export const ABSENCE_BOARD_COLUMN_KEYS = [
  "absencesDiscipline",
  "absencesPeriod",
  "absencesTotal",
  "absencesPercentDiscipline",
  "absencesPercentPeriod",
  "absencesPercentTotal"
];

export const ABSENCE_BOARD_SETTINGS_KEYS = [
  "absencesDiscipline",
  "absencesTotal",
  "absencesPercentDiscipline",
  "absencesPercentTotal"
];

export const GRADES_BOARD_COLUMN_KEY = "grades";

const OPTIONAL_BOARD_COLUMNS = ["callNumber", "ra", ...ABSENCE_BOARD_COLUMN_KEYS];
const DEFAULT_HIDDEN_COLUMNS = [GRADES_BOARD_COLUMN_KEY];

function isPlainObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function mergeColumn(
  existingColumns,
  incomingColumns,
  key,
  forceVisible,
  defaultVisible
) {
  const existing = isPlainObject(existingColumns[key])
    ? existingColumns[key]
    : {};
  const incoming = isPlainObject(incomingColumns[key])
    ? incomingColumns[key]
    : {};
  const merged = { ...existing, ...incoming };
  const fallbackVisible = defaultVisible !== false;

  if (forceVisible) {
    merged.visible = true;
  } else if (typeof merged.visible !== "boolean") {
    merged.visible = fallbackVisible;
  }

  return merged;
}

export function normalizeGeneralBoardConfig(stored, patch) {
  const base = isPlainObject(stored) ? stored : {};
  const incoming = isPlainObject(patch) ? patch : {};
  const result = { ...base, ...incoming };

  const baseColumns = isPlainObject(base.columns) ? base.columns : {};
  const incomingColumns = isPlainObject(incoming.columns)
    ? incoming.columns
    : {};
  const columns = { ...baseColumns, ...incomingColumns };

  OPTIONAL_BOARD_COLUMNS.forEach(key => {
    columns[key] = mergeColumn(baseColumns, incomingColumns, key, false);
  });
  DEFAULT_HIDDEN_COLUMNS.forEach(key => {
    columns[key] = mergeColumn(baseColumns, incomingColumns, key, false, false);
  });
  columns.name = mergeColumn(baseColumns, incomingColumns, "name", true);
  result.columns = columns;

  if (Object.prototype.hasOwnProperty.call(incoming, "highlights")) {
    result.highlights = normalizeHighlights(incoming.highlights);
  } else if (Array.isArray(base.highlights)) {
    result.highlights = normalizeHighlights(base.highlights);
  } else {
    result.highlights = [];
  }

  return result;
}

export function getBoardHighlights(config) {
  return normalizeHighlights(config && config.highlights);
}

export function isBoardColumnVisible(config, key) {
  const columns = config && config.columns;
  const column = isPlainObject(columns) ? columns[key] : null;
  if (!isPlainObject(column) || typeof column.visible !== "boolean") {
    return key !== GRADES_BOARD_COLUMN_KEY;
  }
  return column.visible;
}
